import classNames from 'classnames';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Routes} from '../../../../Routes';

export function AccountHomeLink(props) {
    const {className, dataTestId} = props;

    const intl = useIntl();

    const linkClasses = classNames('link', className);

    return (
        <NavLink
            className={linkClasses}
            data-test-id={dataTestId ?? 'footer-account-home-link'}
            title={intl.formatMessage({id: 'navigation.link.accountHome.title'})}
            to={Routes.HOME}
        >
            <span>
                <FormattedMessage id={'navigation.link.accountHome.text'} />
            </span>
        </NavLink>
    );
}
